module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/4ce2ee74b444e6c1dd7996ffe5c4acb6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_tick_hover.svg
// module id = oHFR
// module chunks = 1